"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tree = require("@ys/utils/lib/tree");
var _vuex = require("vuex");
var _user = require("@/api/crm/user");
var _constants = require("./constants");
var _default = exports.default = {
  props: {
    value: {
      type: String,
      default: undefined
    },
    // 只显示当前登录用户
    onlySelfUser: {
      type: Boolean,
      default: false
    },
    departmentTree: {
      type: Array,
      default: () => []
    },
    departmentId: {
      type: String,
      default: undefined
    },
    allUser: {
      type: Boolean,
      default: false
    },
    keyWord: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      userList: []
    };
  },
  computed: {
    ...(0, _vuex.mapGetters)(['roleList', 'userId']),
    modelValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    currentUserList() {
      if (this.keyWord) {
        return this.userList.filter(user => user?.userName?.includes(this.keyWord));
      }
      return this.userList.filter(user => user.deptId === this.departmentId);
    }
  },
  mounted() {
    this.getUserList();
  },
  methods: {
    async getUserList() {
      const userList = await (0, _user.getUserAllDept)();
      const departmentList = (0, _tree.flatten)(this.departmentTree);
      this.userList = userList.filter(user => {
        if (user.userId === this.userId) {
          return true;
        }
        if (this.onlySelfUser) {
          return false;
        }
        if (this.allUser) {
          return true;
        }
        const department = departmentList.find(department => department.id === user.deptId);
        return department && [_constants.Translate.Manager, _constants.Translate.Normal].includes(department.translate);
      }).map(user => ({
        ...user,
        userIdAndDepartmentId: `${user.userId}-${user.deptId}`
      }));
    },
    handleChange(e) {
      this.$emit('change', {
        value: e.target.value,
        option: this.userList.find(item => item.userIdAndDepartmentId === e.target.value)
      });
    }
  }
};